import React, { forwardRef } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'

const ScrollBar = forwardRef((props, ref) => {
  const { direction = 'ltr', style, ...rest } = props;

  return (
    <Scrollbars
      ref={ref}
      style={{ flexGrow: 1, ...style }} // Use flexGrow: 1 style directly.
      renderView={(props) => (
        <div
          {...props}
          style={{
            ...props.style,
            ...(direction === 'rtl' && { marginLeft: props.style.marginRight, marginRight: 0 }),
          }}
        />
      )}
      {...rest}
    />
  );
});

export default ScrollBar
